module.exports = "/assets/data/aef88e56ac18c86c069161f94985fed4-HR8.data.json";